export default __webpack_public_path__ + "static/media/img1.19e6bd80.png";